import React from 'react';

/**
 * ErrorBoundary — catches DOM errors caused by Google Translate
 * modifying React-owned nodes (removeChild crashes).
 * On error: silently remounts the child component fresh.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorCount: 0 };
  }

  static getDerivedStateFromError(error) {
    // Catch removeChild / Google Translate DOM conflict errors
    if (
      error?.message?.includes('removeChild') ||
      error?.message?.includes('not a child') ||
      error?.name === 'NotFoundError'
    ) {
      return { hasError: true };
    }
    return null;
  }

  componentDidCatch(error, info) {
    // Silent recovery — don't log to console in production
    if (process.env.NODE_ENV === 'development') {
    }
  }

  componentDidUpdate(_, prevState) {
    // Auto-recover after catching — remount child on next tick
    if (this.state.hasError && !prevState.hasError) {
      setTimeout(() => {
        this.setState(s => ({ hasError: false, errorCount: s.errorCount + 1 }));
      }, 50);
    }
  }

  render() {
    if (this.state.hasError) {
      // Render nothing briefly while remounting
      return null;
    }
    // key={errorCount} forces fresh remount after recovery
    return (
      <React.Fragment key={this.state.errorCount}>
        {this.props.children}
      </React.Fragment>
    );
  }
}

export default ErrorBoundary;
